<template>
  <el-form
    ref="form"
    size="mini"
    label-position="right"
    label-width="170px"
    class="demo-ruleForm leftpad"
  >
    <!-- 原始Stress心电图文件 上传下载 -->
    <el-form-item label="原始Stress心电图文件：" :disabled="ecgDisabled">
      <a :href="examEcg.ecgFile" :disabled="ecgDisabled" v-if="examEcg.ecgFile" target="_blank">{{ examEcg.ecgFile }}</a>
      <el-upload
        class="upload-demo"
        ref="uploadStress"
        accept="application/zip"
        :action="uploadPath(false)"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        :auto-upload="false"
        :on-success="uploadSuccess"
      >
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px" size="small" type="success" @click="submitUploadStress($event)">上传到服务器</el-button>
        <div slot="tip" class="el-upload__tip">只能上传zip文件，且不超过30M</div>
      </el-upload>
    </el-form-item>

    <!-- 原始Rest心电图文件 上传下载 -->
    <el-form-item label="原始Rest心电图文件：" :disabled="ecgDisabled">
      <a :href="examEcg.rawRestEcgFile" :disabled="ecgDisabled" v-if="examEcg.rawRestEcgFile" target="_blank" >{{ examEcg.rawRestEcgFile }}</a>
      <el-upload
        class="upload-demo"
        ref="uploadRest"
        accept="application/zip"
        :action="uploadPath(true)"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="uploadSuccessRest"
        :file-list="fileList"
        :auto-upload="false"
      >
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <el-button style="margin-left: 10px" size="small" type="success" @click="submitUploadRest($event)">上传到服务器</el-button>
        <div slot="tip" class="el-upload__tip">只能上传zip文件，且不超过5M</div>
      </el-upload>
    </el-form-item>

    <!--传统静息心电图报告 上传下载 -->
    <el-form-item label="传统静息心电图报告：" :disabled="ecgDisabled">
      <div v-if="examEcg.restPdf !== ''">
        <el-row class="el-row" type="flex">
          <a style="width: 100%" :href="examEcg.restPdf" :disabled="ecgDisabled" v-if="examEcg.restPdf" target="_blank">
            {{ examEcg.restPdf }}
          </a>
          <el-button type="primary" v-if="examEcg.restPdf" class="button-color" @click="showPdf($event,'restShowRef')">展开</el-button>
        </el-row>
        <div >
          <embed ref="restShowRef" :src="examEcg.restPdf" width="100%" height="600px" style="display:none"/>
        </div>
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('pdf')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :on-success="(value)=> uploadPdfSuccess('restPdf', value)"
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :file-list="fileList">
        <el-button style="margin:0px 0px 0px 12px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </el-form-item>
    <!---->

    <!-- 运行心电图文件 上传下载 -->
    <el-form-item label="传统运动心电图报告：" :disabled="ecgDisabled">
      <!-- 如果exercisePdf的路径存在 则显示折叠和 embed pdf插件 -->
    <div>
      <el-row class="el-row" type="flex" >
        <span class="vertical-line"></span>
        <label style="width: 8%">运动前：</label>
        <a :href="examEcg.beforeExercisePdf" style="width: 100%" :disabled="ecgDisabled" v-if="examEcg.beforeExercisePdf" target="_blank">
          {{ examEcg.beforeExercisePdf}}
        </a>
        <div style="float：right width: 100%">        
          <el-button type="primary" class="button-color" v-if="examEcg.beforeExercisePdf" @click="showPdf($event,'beforeExercisePdfRef')">展开</el-button>
        </div>
      </el-row>
      <div>
        <embed ref="beforeExercisePdfRef" :src="examEcg.beforeExercisePdf" width="100%" height="600px" style="display:none"/>
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('pdf')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="1"
        :on-exceed="handleExceed"
        :on-success="(value)=> uploadPdfSuccess('beforeExercisePdf', value)"
        :auto-upload="true"
        :file-list="fileList">
        <span class="vertical-line"></span>
        <el-button style="margin:0px 0px 0px 0px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </div>

    <div>
      <el-row class="el-row" type="flex" >
      <span class="vertical-line"></span>
      <label style="width: 8%">运动中：</label>
      <a style="width: 100%" :href="examEcg.inExercisePdf" :disabled="ecgDisabled" v-if="examEcg.inExercisePdf" target="_blank">
        {{ examEcg.inExercisePdf }}
      </a>
      <div style="float：right width: 100%">        
        <el-button type="primary" class="button-color" v-if="examEcg.inExercisePdf" @click="showPdf($event,'inExercisePdfRef')">展开</el-button>
      </div>
      </el-row>
      <div>
        <embed ref="inExercisePdfRef" :src="examEcg.inExercisePdf" width="100%" height="600px" style="display:none"/>
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('pdf')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :on-success="(value)=> uploadPdfSuccess('inExercisePdf', value)"
        :file-list="fileList">
        <span class="vertical-line"></span>
        <el-button style="margin:0px 0px 0px 0px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    <div>
      <el-row class="el-row" type="flex" >
      <span class="vertical-line"></span>
        <label style="width: 8%">运动后：</label>
      <a style="width: 100%" :href="examEcg.postExercisePdf" :disabled="ecgDisabled" v-if="examEcg.postExercisePdf" target="_blank">
        {{ examEcg.postExercisePdf }}
      </a>
      <div style="float：right width: 100%">        
        <el-button type="primary" class="button-color" v-if="examEcg.postExercisePdf" @click="showPdf($event,'postExercisePdfRef')">展开</el-button>
      </div>
      </el-row>

      <div>
        <embed ref="postExercisePdfRef" :src="examEcg.postExercisePdf" width="100%" height="600px" style="display:none"/>
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('pdf')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :on-success="(value)=> uploadPdfSuccess('postExercisePdf', value)"
        :file-list="fileList">
        <span class="vertical-line"></span>
        <el-button style="margin:0px 0px 0px 0px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </div>
    </el-form-item>

    <!-- EIS 文件 上传下载 -->
    <el-form-item label="最终报告：" :disabled="ecgDisabled">
      <el-row class="el-row" type="flex" >
      <a style="width: 100%" :href="examEcg.eisPdf" :disabled="ecgDisabled" v-if="examEcg.eisPdf" target="_blank">
        {{ examEcg.eisPdf }}
      </a>
      <!-- <div style="float：right width: 100%">        
        <el-button  type="primary" class="button-color"  v-if="examEcg.eisPdf" @click="showPdf($event,'eisPdfRef')">展开</el-button>
      </div> -->
      </el-row>
      <div>
        <embed ref="eisPdfRef" :src="examEcg.eisPdf" width="100%" height="600px" style="display:none" />
      </div>
      <el-upload
        class="upload-demo"
        :action="upload4Cospath('report')"
        :on-preview="handlePreview"
        accept="application/pdf"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        :limit="1"
        :on-exceed="handleExceed"
        :auto-upload="true"
        :on-success="(value)=> uploadPdfSuccess('eisPdf', value)"
        :file-list="fileList">
        <el-button style="margin:0px 0px 0px 0px;" size="mini" type="primary">点击上传</el-button>
      </el-upload>
    </el-form-item>

    <el-form-item label="静息心电图诊断结论：">
      <el-input v-model="examEcg.restEcgConclusion" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item label="运动心电图诊断结论：">
      <el-input v-model="examEcg.exerciseEcgConclusion" :disabled="disabled"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button :loading="submitting" type="primary" @click="_updateExamEcg" size="medium" class="fullWidth" v-show="!disabled" >保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { ExamStatesValue } from "../../utils/constants";
import { Util_updateExamState } from "../../utils/util";
import {
  getExamEcg,
  updateExamEcg,
  updateExamState
  } from "../../api/userExamService";
import { baseURL } from "../../api/axiosCreator";
export default {
  props: {
    examUuid: String,
    disabled: Boolean,
    ecgDisabled: Boolean,
  },
  data() {
    return {
      fileList: [],
      uploadFileModel: "",
      submitting: false,
      //心电检查
      examEcg: {
        examUuid: "",
        ecgFile: "",
        rawRestEcgFile: "",
        restPdf: "",
        beforeExercisePdf: "",
        inExercisePdf: "",
        postExercisePdf: "",
        eisPdf: "",
        restEcgConclusion: "",
        exerciseEcgConclusion: ""
      }
    };
  },
  watch: {},
  methods: {
    showPdf(e, ref){
				let isHidden = this.$refs[ref].style.display == "none";
        if(isHidden) {
          this.$refs[ref].style.display = "block";
          e.currentTarget.textContent = "折叠";
        }else {
          this.$refs[ref].style.display = "none";
          e.currentTarget.textContent = "展开";
        }
		},
    //获取心电图检查
    _getExamEcg() {
      getExamEcg(this.examUuid).then((res) => {
        if (res.success) {
          if (res.data[0]) {
            this.examEcg = res.data[0];
          }
        } else {
          this.$message({ message: res.description, type: "error" });
        }
        console.log(true);
      });
    },
    //更新基础问询
    _updateExamEcg() {
      this.submitting = true;
      //转换格式发送给后端;
      updateExamEcg(this.examEcg)
        .then((res) => {
          this.submitting = false;
          if (res.success) {
            this.$message({ message: res.description, type: "success" });
            //更新检查状态后，重新获取检查信息
            this._updateExamState(ExamStatesValue.ECG_60, this._getExamEcg);
          } else {
            this.$message({
              message: res.description,
              type: "warning",
            });
          }
        })
        .catch((e) => {
          this.submitting = false;
          console.log(e);
        });
    },
    //更新检查状态、并重新获取更新的信息
    _updateExamState(state, reloadFunc) {
      //如果已到达，则将其状态改为30:基础问询中
      Util_updateExamState(
        this.examUuid,
        state,
        updateExamState,
        reloadFunc,
        this.$message
      );
    },
    submitUploadRest() {
      this.$refs.uploadRest.submit();
    },
    submitUploadStress() {
      this.$refs.uploadStress.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    uploadSuccess(res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        this.fileList.pop();
        let url = res.data[0];
        this.examEcg.ecgFile = url;
        this.$EventBus.$emit("ecgFileUploaded","");
      } else {
        this.$message.error("上传失败，请重新上传");
      }
    },
    uploadSuccessRest(res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        this.fileList.pop();
        let url = res.data[0];
        this.examEcg.rawRestEcgFile = url;
        this.$EventBus.$emit("ecgFileUploadedRest","");
      } else {
        this.$message.error("上传失败，请重新上传");
      }
    },

    uploadPdfSuccess(ref,res) {
      if (res.success) {
        this.$message({ message: "恭喜你，上传成功", type: "success" });
        let url = res.data[0];
        if(ref=='restPdf') {
          this.examEcg.restPdf = url;
        }
        if(ref=='beforeExercisePdf') {
          this.examEcg.beforeExercisePdf = url;
        }
        if(ref=='inExercisePdf') {
          this.examEcg.inExercisePdf = url;
        }
        if(ref=='postExercisePdf') {
          this.examEcg.postExercisePdf = url;
        }
        if(ref=='eisPdf') {
          this.examEcg.eisPdf = url;
        }
        this.fileList.pop();
      } else {
        this.$message.error("上传失败，请重新上传");
      }
      return;
    },

    uploadError() {
      this.$refs.upload.clearFiles();
      this.$message.error("上传失败，请重新上传");
    },
  },
  computed: {
    uploadPath() {
      return (isRest) => {
        return ( baseURL + "/ExamService/uploadFile/" + this.examUuid +"/zip/" + isRest);
      };
    },
    upload4Cospath() {
      return (type) => {
        return (baseURL + "/ExamService/uploadFile4Cos/" + this.examUuid + "/" +type + "/" + true);
      };
    }
  },
  created() {
    this.examEcg.examUuid = this.examUuid;
    this._getExamEcg();
  },
};
</script>

<style scoped>
.fullWidth {
  width: 100%;
}
.vertical-line{
    display: inline-block;
    border-left: 1px solid #ccc;
    margin: 0px 10px -40px 0px;
    padding: 7px  0px  7px  0px;
    height: 40px;
}
.button-color{
    background-color: #67C23A; 
    border-color: #67C23A;
}


</style>